export default __webpack_public_path__ + "static/media/wadelivery_background.97a98a68.png";